import React from "react";
import { TextInput } from "@jsq/ds/core";
import { createFieldPlaceholder } from "./utils";
import type { FieldEditorProps } from "./types";

/**
 * Text Field Editor Component
 *
 * Specialized input component for text extension fields.
 * Provides text input with proper validation and formatting.
 * Uses design system styling for consistency.
 */
export const TextFieldEditor: React.FC<FieldEditorProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
}) => {
  return (
    <TextInput
      value={value}
      onSetValue={onChange}
      placeholder={createFieldPlaceholder(field)}
      disabled={disabled}
      errorMessage={error || undefined}
      isFullWidth
      data-testid="text-field-editor"
    />
  );
};

export default TextFieldEditor;
